import { CH_ACCOUNT } from '../constants/general';
import { getValueByMultiProps } from '../utils/mapper';
import store from '../redux/store';
import { createNotification, createNotificationAction } from '../redux/actions/uiActions';

export const REQUEST_TIMEOUT_STATUS = 504;

export const handleResponse = (response, reload = true, config = { notifyError: false, returnStatus: false }) =>
  response.text().then((text) => {
    const { status } = response;
    const data = text && JSON.parse(text);
    if (!response.ok) {
      console.error('Network request error:', data);

      if ((response.status === 401 || response.status === 403) && reload) {
        console.trace();
        window.localStorage.removeItem(CH_ACCOUNT);
        // window.location.reload();
      }
      const error = getValueByMultiProps(data?.error || data, ['error_message', 'message', 'code']);
      if (error && config.notifyError) {
        store.dispatch(createNotification('error', error, 3500));
      }
      const errorPayload = config.returnStatus ? { status, data } : data;
      return Promise.reject(errorPayload);
    }
    return data;
  });

export const advancedHandleResponse = (response) =>
  handleResponse(response, false, { notifyError: true, returnStatus: true });
